const GetPrivacyPolicyByLanguage = (prop: any): string => {
    const policy: any = new Map<string, string>([
        ['es', 'https://www.hp.com/es-es/privacy/privacy.html'],
        ['en', 'https://www.hp.com/us-en/privacy/privacy.html'],
        ['pt', 'https://www.hp.com/br-pt/privacy/privacy.html']
    ]);
    return policy.get(prop);
}
export default GetPrivacyPolicyByLanguage;